import {
  ResourcePage,
  SearchResultDto,
  SearchType,
} from 'src/graphql/generated/graphql';

export const ItemColumn = ({ item }: { item: Partial<SearchResultDto> }) => {
  switch (item.type) {
    case SearchType.Resource:
      const parsedData = JSON.parse(item.data as string) as ResourcePage;
      return parsedData.name;
    default:
      return item.id;
  }
};
